import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import axios from "axios";

import Input from "components/Input";
import Select from "components/Select";
import ToggleSwitch from "components/ToggleSwitch";
import CNBTextArea from "components/CNBTextArea";
import { signOptions, deliveryDaysOptions } from "../constants";
import PreferencesActions from "./actions";
import Button from "components/Button";

import "./style.scss";

interface IProps {
  itemOptions: any[];
  getItemOptions: () => void;
  classOptions: any[];
  getClasses: () => void;
  savePreferences: (data: any) => void;
  settings: any;
  getPreferences: () => void;
  roleIds: any[];
  getSelectOptions: () => void;
  freightCosts: any[];
  amStatusOptions: any[];
}

interface IState {
  data: any;
  articleOptions: any[];
}

const kegStandardFromOptions = [
  { label: "Derde", value: "ThirdParty" },
  { label: "Koper", value: "Buyer" },
  { label: "Verkoper", value: "Seller" },
];

class DeliveryPreferences extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        deliveryDate: {
          sign: "+",
          days: 0,
        },
        harvestYear: {},
        status: "AMVrij",
      },
      articleOptions: [],
    };
  }

  public componentDidMount() {
    const {
      itemOptions,
      classOptions,
      getPreferences,
      getItemOptions,
      getClasses,
      getSelectOptions,
      freightCosts,
    } = this.props;
    getPreferences();
    _.isEmpty(itemOptions) && getItemOptions();
    _.isEmpty(classOptions) && getClasses();
    _.isEmpty(freightCosts) && getSelectOptions();
    const url =
      "Items?$select=Id,Description&$filter=TypeId eq 'Packaging' and Active eq true and PortalActive eq true and (Number eq 'F0009' or Number eq 'F0010')";
    axios.get(url).then(({ data }) => {
      const articleOptions = _.map(
        _.get(data, "value", []),
        ({ Description: label, Id: value }) => ({
          label,
          value,
        })
      );
      // this.clearData();
      this.setState({ articleOptions });
    });
  }

  public componentWillReceiveProps(nextProps) {
    if (
      !_.isEmpty(nextProps.settings) &&
      !_.isEqual(nextProps.settings, this.state.data)
    ) {
      this.setState({
        data: _.get(nextProps, "settings.Settings", this.state.data),
      });
    } else if (nextProps.classOptions && nextProps.classOptions.length) {
      const data = this.state.data;
      const value = nextProps.classOptions.find((c) => c.label === "I J");
      _.set(data, "class", value);
      this.setState({ data });
    }
  }

  private toggleSwitch(name) {
    const data = this.state.data;
    _.setWith(data, name, !data[name], Boolean);
    this.setState({ data });
  }

  private handleChange(event, { name }) {
    const data = this.state.data;
    _.set(data, name, event?.value);
    this.setState({ data });
  }

  private clearData = () => {
    const data = {
      deliveryDate: {
        sign: "+",
        days: 0,
      },
      harvestYear: {},
      status: "AMVrij",
      invoiceComment: "",
      note: "",
    };
    this.setState({ data });
  };

  private maskOnInput = (e) => {
    const value = e.target.validity.valid
      ? e.target.value
      : _.get(this.state.data, e.target.name, "");
    const event = { value };
    this.handleChange(event, { name: e.target.name });
  };

  public render() {
    const { data, articleOptions } = this.state;
    const {
      itemOptions,
      classOptions,
      savePreferences,
      roleIds,
      freightCosts,
      amStatusOptions,
    } = this.props;
    return (
      <div id="preferences-page">
        <FormattedMessage id="PREFERENCES" tagName="h1" />
        <div className="flex-row">
          <ToggleSwitch
            label="DELIVERIES_REPORT"
            on={data.report}
            onClick={() => this.toggleSwitch("report")}
          />
        </div>
        <div className="flex-row">
          <Select
            label="PURCHASE_TYPE"
            selectedOption={data.type}
            options={roleIds.filter((r) => r.value !== "Buyer")}
            onChange={(event) => {
              return this.handleChange(event, { name: "type" });
            }}
          />
        </div>
        <hr />
        <div className="flex-row">
          <Select
            label="PREFERENCES_TULIP_DELIVERY"
            selectedOption={data.tulipStandard}
            options={itemOptions}
            onChange={(event) =>
              this.handleChange(event, { name: "tulipStandard" })
            }
          />
        </div>
        <div className="flex-row">
          <Select
            label="PREFERENCES_LILY_DELIVERY"
            selectedOption={data.lilyStandard}
            options={itemOptions}
            onChange={(event) =>
              this.handleChange(event, { name: "lilyStandard" })
            }
          />
        </div>
        <div className="flex-row">
          <Select
            label="PREFERENCES_OTHERS_DELIVERY"
            selectedOption={data.othersStandard}
            options={itemOptions}
            onChange={(event) =>
              this.handleChange(event, { name: "othersStandard" })
            }
          />
        </div>
        <div className="flex-row">
          <Select
            label="PREFERENCES_OTHERS_ST"
            selectedOption={data?.kegStandardFromValue}
            options={kegStandardFromOptions}
            onChange={(event) =>
              this.handleChange(event, { name: "kegStandardFromValue" })
            }
          />
        </div>
        <div className="flex-row">
          <Input
            label="PREFERENCES_FUST_REMARKS"
            value={data.fustComment}
            name="fustComment"
            onChange={({ target }) =>
              this.handleChange(target, { name: "fustComment" })
            }
            maxLength={70}
          />
        </div>
        <hr />
        <div className="flex-row">
          <Select
            label="PREFERENCES_CONTAINER"
            selectedOption={data.containerStandard}
            onChange={(event) =>
              this.handleChange(event, { name: "containerStandard" })
            }
            options={articleOptions}
          />
        </div>
        <div className="flex-row">
          <Select
            label="PREFERENCES_LILY_ST"
            selectedOption={data.createLilyStandard}
            onChange={(event) =>
              this.handleChange(event, { name: "createLilyStandard" })
            }
            options={articleOptions}
          />
        </div>
        <div className="flex-row">
          <Input
            label="PREFERENCES_CARRIER_REMARKS"
            value={data.carrierComment}
            name="carrierComment"
            onChange={({ target }) =>
              this.handleChange(target, { name: "carrierComment" })
            }
            maxLength={70}
          />
        </div>
        <hr />
        <div className="flex-row">
          <Select
            label="DELIVERIES_REQUIREMENTS"
            selectedOption={data.franking}
            options={freightCosts}
            onChange={(event) => this.handleChange(event, { name: "franking" })}
          />
        </div>
        <div className="flex-row">
          <Input
            label="DELIVERIES_TRANSPORTER"
            value={data.transporter}
            name="transporter"
            onChange={({ target }) =>
              this.handleChange(target, { name: "transporter" })
            }
            maxLength={50}
          />
        </div>
        <div className="flex-row">
          <Input
            label="DELIVERIES_CITY"
            value={data.deliveryFrom}
            name="deliveryFrom"
            onChange={({ target }) =>
              this.handleChange(target, { name: "deliveryFrom" })
            }
            maxLength={35}
          />
        </div>
        <div className="flex-row">
          <ToggleSwitch
            label="PREFERENCES_LOGO"
            on={data.logo}
            onClick={() => this.toggleSwitch("logo")}
          />
        </div>
        <hr />
        <div className="flex-row">
          <CNBTextArea
            label="PREFERENCES_COMMENT"
            value={data.note}
            name="note"
            onChange={({ target }) =>
              this.handleChange(target, { name: "note" })
            }
            maxLength={250}
          />
        </div>
        <div className="flex-row">
          <CNBTextArea
            label="PREFERENCES_INVOICE_NOTE"
            value={data.invoiceComment}
            name="invoiceComment"
            onChange={({ target }) =>
              this.handleChange(target, { name: "invoiceComment" })
            }
            maxLength={80}
          />
        </div>
        <hr />
        <div className="flex-row">
          <Select
            label="DELIVERIES_AM"
            selectedOption={data.status}
            options={amStatusOptions}
            onChange={(event) => this.handleChange(event, { name: "status" })}
          />
        </div>
        <div className="flex-row">
          <Select
            label="DELIVERIES_CLASS"
            selectedOption={data.class}
            options={classOptions}
            onChange={(event) => this.handleChange(event, { name: "class" })}
          />
        </div>
        <hr />
        <div className="flex-row">
          <FormattedMessage id="DELIVERIES_DATE" tagName="label" />
          <span className="title">
            <FormattedMessage id="CURRENT_DATE" />
          </span>
          <Select
            containerClassName="small-select"
            placeholder=""
            selectedOption={data.deliveryDate.sign}
            options={signOptions}
            onChange={(event) =>
              this.handleChange(event, { name: "deliveryDate.sign" })
            }
          />
          <Select
            containerClassName="small-select"
            placeholder=""
            selectedOption={data.deliveryDate.days}
            options={deliveryDaysOptions}
            onChange={(event) =>
              this.handleChange(event, { name: "deliveryDate.days" })
            }
          />
          <span className="title days">
            <FormattedMessage id="DAYS" />
          </span>
        </div>
        <hr />
        <div className="flex-row">
          <FormattedMessage id="PREFERENCES_HARVEST_YEAR" tagName="label" />
          <Input
            className="small-input"
            value={data.harvestYear.from}
            name="harvestYear.from"
            maxLength={4}
            pattern="[0-9]*"
            onChange={this.maskOnInput}
          />
          <span className="title">-</span>
          <Input
            className="small-input"
            value={data.harvestYear.to}
            name="harvestYear.to"
            maxLength={4}
            pattern="[0-9]*"
            onChange={this.maskOnInput}
          />
        </div>
        <div className="flex-row buttons-row">
          <Button
            id="save-preferences"
            kind="primary"
            onClick={() => savePreferences(data)}
          >
            SAVE
          </Button>
          <Button onClick={this.clearData}>CLEAR</Button>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    itemOptions: state.preferences.itemOptions,
    classOptions: state.preferences.classOptions,
    settings: state.preferences.settings,
    roleIds: state.app.roleIds,
    freightCosts: state.preferences.freightCosts,
    amStatusOptions: state.preferences.amStatusOptions,
  }),
  {
    getItemOptions: PreferencesActions.getItemOptions,
    getClasses: PreferencesActions.getClasses,
    savePreferences: PreferencesActions.savePreferences,
    getPreferences: PreferencesActions.getPreferences,
    getSelectOptions: PreferencesActions.getSelectOptions,
  }
)(DeliveryPreferences);
